// extracted by mini-css-extract-plugin
export default {"search_button":"emrPanel_search_button__VSWGp","container":"emrPanel_container__jQU-Y"};